export default __webpack_public_path__ + "static/media/astro.4178b58b.png";